import { render, staticRenderFns } from "./dokAdministrasi.vue?vue&type=template&id=4cc1118e"
import script from "./dokAdministrasi.vue?vue&type=script&lang=js"
export * from "./dokAdministrasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports